
import { getStatGradeClass } from '@/utils/colorUtils'


export const GRADE_VALUES = {
  'S+': 12,
  'S': 11,
  'S-': 10,
  'A+': 9,
  'A': 8,
  'A-': 7,
  'B+': 6,
  'B': 5,
  'B-': 4,
  'C+': 3,
  'C': 2,
  'C-': 1,
  'D+': 0,
  'D': -1,
  'D-': -2,
  'E': -3,
  'F': -4
}

export const getStatGrade = (value) => {
    // Ensure value is between 0 and 200
    const clampedValue = Math.min(200, Math.max(0, value))
    
    if (clampedValue >= 190) return 'S+'
    if (clampedValue >= 180) return 'S'
    if (clampedValue >= 170) return 'S-'
    if (clampedValue >= 150) return 'A+'
    if (clampedValue >= 125) return 'A'
    if (clampedValue >= 101) return 'A-'
    if (clampedValue >= 91) return 'B+'
    if (clampedValue >= 90) return 'B'
    if (clampedValue >= 80) return 'B-'
    if (clampedValue >= 70) return 'C+'
    if (clampedValue >= 60) return 'C'
    if (clampedValue >= 50) return 'C-'
    if (clampedValue >= 40) return 'D+'
    if (clampedValue >= 30) return 'D'
    if (clampedValue >= 20) return 'D-'
    if (clampedValue >= 10) return 'E'
    return 'F'
  }
  
  export const StatBadge = (stat, value) => {
    const grade = getStatGrade(value)
    const gradeClass = getStatGradeClass(grade)
    return {
      grade,
      class: gradeClass,
      value,
      display: `${stat}: ${grade} (${value})`
    }
  }
  
  export { getStatGradeClass } from '@/utils/colorUtils'